// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mui-rte-root{min-width:auto}#mui-rte-Save-button{color:#00bcd4}\n", ""]);
// Exports
module.exports = exports;
